module.exports = __webpack_public_path__ + "static/media/EnCORE_consent_FR_p2.dd213571.jpg";